<template>
  <v-flex class="cStatement" data-qa="domesticpaymentsreview-flex-2uj5yy8">
    <div class="transferReview" data-qa="domesticpaymentsreview-div-4yevav">
      <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="domesticpaymentsreview-layout-1ebtz">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient, height: '180px' }"
         data-qa="domesticpaymentsreview-flex-mju4nx">
          <v-container class="transferFunds--title-padding" data-qa="domesticpaymentsreview-container-cz0lwn">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="domesticpaymentsreview-flex-hod7ah">
              <v-row no-gutters data-qa="domesticpaymentsreview-row-q9ioq">
                <v-layout row wrap class="pb-2" data-qa="domesticpaymentsreview-layout-khzu7f">
                  <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="domesticpaymentsreview-flex-7btu69">
                    <v-row justify="end" data-qa="domesticpaymentsreview-row-40dmb">
                      <v-avatar :tile="false" size="35" color="white" data-qa="domesticpaymentsreview-avatar-mryq8u">
                        <v-icon :color="primaryColor" data-qa="domesticpaymentsreview-icon-x5p2q9">mdi-sync</v-icon>
                      </v-avatar>
                    </v-row>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="domesticpaymentsreview-flex-fl98be">
                    <v-row no-gutters data-qa="domesticpaymentsreview-row-cfja19">
                      <font class="text-h5 font-weight-light white--text">
                        {{ $t("domesticPayments.title") }}</font
                      >
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>

      <v-flex
        xs12
        sm12
        md12
        lg10
        xl10
        class="pl-12 cStatement--overlayCardFlex"
       data-qa="domesticpaymentsreview-flex-5d6cw">
        <v-layout row wrap class="pl-12" data-qa="domesticpaymentsreview-layout-7nh8l5">
          <v-flex xs12 sm12 md12 lg10 xl10 class="pt-4" data-qa="domesticpaymentsreview-flex-atgu6i">
            <v-card data-qa="domesticpaymentsreview-card-79579j">
              <v-card-text class="text--primary" data-qa="domesticpaymentsreview-card-text-idbul">
                <v-row no-gutters class="py-2" data-qa="domesticpaymentsreview-row-0e0i3">
                  <DisplayDetails
                    :config="{
                      title: 'Summary',
                      dataList: summaryDetails,
                      translation: 'domesticPayments',
                    }"
                    class="pl-6"
                  />
                </v-row>
                <v-row
                  v-if="
                    config.payload.paymentFrequency === 'ONCE' &&
                    isFuturePayment()
                  "
                  no-gutters
                  class="px-8"
                 data-qa="domesticpaymentsreview-row-055285">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="domesticpaymentsreview-alert-eciyl8">
                    <font class="body-2 font-weight-regular">
                      {{ $t("domesticPayments.scheduledPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
                <v-row
                  v-if="config.payload.paymentFrequency !== 'ONCE'"
                  no-gutters
                  class="px-8"
                 data-qa="domesticpaymentsreview-row-f11l1">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="domesticpaymentsreview-alert-vc650q">
                    <font class="body-2 font-weight-regular">
                      {{ $t("domesticPayments.scheduledRecurringPaymentInfo") }}
                    </font>
                  </v-alert>
                </v-row>
              </v-card-text>

              <v-card-actions class="pl-8 pt-3 pb-8" data-qa="domesticpaymentsreview-card-actions-valb19">
                <v-layout wrap data-qa="domesticpaymentsreview-layout-awxml8">
                  <v-btn
                    @click="goBack"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    outlined
                    class="text-capitalize ma-2 pl-10 pr-10 py-2 px-4"
                   data-qa="domesticpaymentsreview-btn-mjtcv9">
                    {{ $t("domesticPayments.backButton") }}
                  </v-btn>
                  <v-btn
                    @click="confirmTransfer"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    :width="107" 
                    :height="36"
                    class="text-capitalize ma-2 pl-16 pr-16 white--text py-2 px-4"
                   data-qa="domesticpaymentsreview-btn-fv0m0e">
                    {{ $t("domesticPayments.confirmButton") }}
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- OTP -->
      <Modal
        v-if="enableOTP && showOTPScreen"
        @cancel="onOtpModalClose"
        :config="modalConfig.otp"
      >
        <span slot="modalContent" data-qa="domesticpaymentsreview-span-wkkrxq">
          <OtpInput :otpConfig="otpSettings" />
        </span>
      </Modal>
      <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
      <Modal
        v-if="successDialog"
        :config="modalConfig.successModal"
        @btn1Action="newTransferRequest"
        @btn2Action="returnToDashboard"
        @btn3Action="downloadPaymentProofEnabled"
      >
      </Modal>
      <PaymentFailureDialog
        :show="failureDialog.show"
        :retry="false"
        :error-list="failureDialog.errorList"
        @goBack="handleGoBack"
        @cancelTransfer="newTransferRequest"
      />
    </div>
  </v-flex>
</template>

<script>
import '@/styles/pages/consolidatedStatement.scss'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import UKFPSpaymentTemplate from '@/plugins/UKFPSconfig'
import event from '@/util/event'
import moment from 'moment'
import preload from '@/util/preload'
import PaymentSuccessDialog from '../common/PaymentSuccessDialog.vue'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'

export default {
  name: 'DomesticPaymentsReview',
  props: {
    config: {
      type: Object,
      default: undefined
    },
    display: {
      type: Object,
      default: undefined
    },
    isInitiateDomesticFailed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput,
    DisplayDetails,
    PaymentSuccessDialog,
    PaymentFailureDialog,
    DownloadPaymentProof
  },
  data () {
    return {
      UKFPSpaymentTemplate,
      endPeriodDate: '',
      confirmAccountTransfer: true,
      successDialog: false,
      successResponse: '',
      disableBtn: false,
      summaryDetails: [],
      confirmationDetails: [],
      setOTPAuthentication: this.$appSettings.defaultConfigurations,
      enableOTP: this.$appSettings.defaultConfigurations
        .enableOTPToDomesticPayment,
      defaultCurrency: this.$appSettings.defaultConfigurations.currencyFormat
        .currency,
      currentDate: moment().format('YYYY-MM-DD'),
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successModal: {
          persistent: true,
          dataListTranslation: 'domesticPayments',
          title: this.$t('paymentSuccessDialog.transferInitiated'),
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      isNotice: ['NACC', 'TXNA'].includes(this.display.viewOnly.fromAccType) && 'chargeAmt' in this.display.viewOnly,
      isNoticeAccrued: ['NACC', 'TXNA'].includes(this.display.viewOnly.fromAccType) && this.display.viewOnly?.penaltyDetails?.penaltyAmount,
      failureDialog: {
        show: false,
        errorList: []
      },
      currentTime: new Date().toLocaleTimeString('en-GB'),
      showDownloadPayment: true,
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
    }
  },
  created () {
    this.setSummaryData()
    this.generateEndDate(this.config.payload.frequencyMonths)
    event.$on('IS_OTP_VALID', (val) => {
      this.modalConfig.otp.enabled = true
      this.saveTransferData()
    })
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  methods: {
    setSummaryData () {
      const { payload } = this.config
      const { viewOnly } = this.display
      const { format } = this.$formatter.currency

      const addDetail = (label, value, valueClass) => {
        this.summaryDetails.push({ label, value, valueClass })
      }

      this.summaryDetails = []
      this.summaryDetails.push({
        label: 'fromLabel',
        value: payload.fromAccount.selectedAccountText,
        subValue: payload.fromAccount.selectedAccountHintText
      })
      this.summaryDetails.push({
        label: 'toLabel',
        value: viewOnly.payeeAccountName,
        subValue: viewOnly.senderAccName
      })
      addDetail('amountLabel', format(payload.transferAmount, payload.currencyFormat))

      if (this.isPayorLisa) {
        addDetail('charge', format(this.totalLisaCharges + payload.domesticPaymentCharges, payload.currencyFormat), 'red--text')
        addDetail('payeeReceives', format(payload.transferAmount - this.totalLisaCharges, payload.currencyFormat))
      } else if (payload.domesticPaymentCharges !== undefined) {
        addDetail('charge', format(payload.domesticPaymentCharges, payload.currencyFormat))
      }
      if (this.isNotice) {
        if (this.isNoticeAccrued) {
          if (viewOnly.penaltyDetails.penaltyAmount.value > 0) {
            addDetail('loiCharges', format(viewOnly.penaltyDetails.penaltyAmount.value, viewOnly.penaltyDetails.penaltyAmount.currency))
          }
          addDetail('payeeReceives', format(payload.transferAmount, payload.currencyFormat))
        } else {
          addDetail('loiCharges', format(viewOnly.chargeAmt, viewOnly.penaltyDetails.chargeAmount.currency))
        }
      }
      if (payload.paymentFrequency !== 'ONCE') {
        addDetail('frequencyDaysLabel', payload.paymentFrequency)
        addDetail('selectTimes', payload.frequencyMonths)
      }
      addDetail(payload.paymentFrequency !== 'ONCE' ? 'paymentStartDate' : 'quickPaymentDateLabel',
        this.$formatter.formatDate(payload.startDate))
      addDetail('reviewNoteLabel', payload.transferNote)
    },
    setConfirmationData () {
      const { payload } = this.config
      const { viewOnly } = this.display

      this.confirmationDetails.push(
        {
          label: 'fromLabel',
          value: payload.fromAccount.selectedAccountText,
          subValue: payload.fromAccount.selectedAccountHintText
        },
        {
          label: 'toLabel',
          value: this.display.viewOnly.payeeAccountName,
          subValue: this.display.viewOnly.senderAccName
        },
        {
          label: 'amountLabel',
          value: this.$formatter.currency.format(
            payload.transferAmount,
            payload.currencyFormat
          )
        }
      )
      this.downloadDataDetails = []
      this.downloadDataDetails.push(
        {
          label: 'fromAcc', value: payload?.fromAccount?.selectedAccountText, subValue: this.$formatter.maskNumber((payload.fromAccount?.selectedAccountHintText?.split(' ')[0]))
        },
        {
          label: 'toAcc', value: viewOnly?.payeeAccountName, subValue: `${this.$formatter.maskNumber(payload?.toAcc)} | ${this.display?.viewOnly?.senderAccName?.split('|')[1]}`
        },
        {
          label: 'amount', value: this.$formatter.currency.format(payload?.transferAmount, payload?.currencyFormat)
        }
      )
      if (payload.paymentFrequency !== 'ONCE') {
        this.confirmationDetails.push(
          {
            label: 'frequencyDaysLabel',
            value: payload.paymentFrequency
          },
          {
            label: 'selectMonthsLabel',
            value: payload.frequencyMonths
          }
        )
        this.downloadDataDetails.push(
          { label: 'frequency', value: payload?.paymentFrequency },
          { label: 'noOfPayments', value: payload?.frequencyMonths }
        )
      }
      this.confirmationDetails.push(
        {
          label:
            payload.paymentFrequency !== 'ONCE'
              ? 'paymentStartDate'
              : 'quickPaymentDateLabel',
          value: this.$formatter.formatDate(payload?.startDate)
        },
        {
          label: 'reviewNoteLabel',
          value: payload.transferNote
        }
      )
      if (this.display.viewOnly?.penaltyDetails?.penaltyAmount) {
        if (this.display.viewOnly?.penaltyDetails?.penaltyAmount?.value > 0) {
          this.confirmationDetails.push({
            label: 'loiCharges',
            value: this.$formatter.currency.format(viewOnly.penaltyDetails.penaltyAmount.value, viewOnly.penaltyDetails.penaltyAmount.currency)
          })
          this.downloadDataDetails.push({
            label: 'charges',
            value: this.$formatter.currency.format(viewOnly.penaltyDetails.penaltyAmount.value, viewOnly.penaltyDetails.penaltyAmount.currency)
          })
        }
        this.confirmationDetails.push({
          label: 'payeeReceives',
          value: this.$formatter.currency.format(payload.transferAmount, payload.currencyFormat)
        })
      }
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.disableBtn = false
      this.showOTPScreen = false
    },
    generateEndDate (val) {
      const calcDays = Number(val)
      const frequencyList = this.config.payload.paymentFrequency
      const startDate = this.config.payload.startDate
      const endDateMoment = moment(startDate)
      switch (frequencyList) {
        case 'ONCE':
          this.endPeriodDate = endDateMoment
            .add(calcDays + 2, 'days')
            .toISOString()
            .substr(0, 10)
          break
        case 'DAILY':
          this.endPeriodDate = endDateMoment
            .add(calcDays + 2, 'days')
            .toISOString()
            .substr(0, 10)
          break
        case 'BI-MONTHLY':
          var timeMonths = Math.ceil(calcDays / 2)
          this.endPeriodDate = endDateMoment
            .add(timeMonths, 'months')
            .toISOString()
            .substr(0, 10)
          break
        case 'MONTHLY':
          this.endPeriodDate = endDateMoment
            .add(calcDays, 'months')
            .toISOString()
            .substr(0, 10)
          break
        case 'QUARTERLY':
          this.endPeriodDate = moment(startDate)
            .quarter(calcDays + 1)
            .endOf('quarter')
            .toISOString()
            .substr(0, 10)
          break
        case 'HALF-YEARLY':
          var timeHalfYearly = Math.ceil(calcDays / 2)
          this.endPeriodDate = endDateMoment
            .add(timeHalfYearly, 'years')
            .toISOString()
            .substr(0, 10)
          break
        case 'YEARLY':
          this.endPeriodDate = endDateMoment
            .add(calcDays, 'years')
            .toISOString()
            .substr(0, 10)
          break
        default:
          console.log('ERROR')
      }
    },
    confirmTransfer () {
      this.disableBtn = true
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.saveTransferData()
      }
      this.$emit('reset_isInitiateDomesticFailed', true)
    },
    newTransferRequest () {
      this.successDialog = false
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    },
    returnToDashboard () {
      this.$router.push('/home')
    },
    goBack () {
      event.$emit('IS_REVIEW_CLEAR', { type: 'GoBack' })
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      this.downloadDataDetails.push(
        {
          label: this.config?.payload?.paymentFrequency !== 'ONCE' ? 'paymentStartDate' : 'paymentDate',
          value: this.isFuturePayment() ? this.$formatter.formatDate(this.config?.payload?.startDate) : `${this.$formatter.formatDate(this.config?.payload?.startDate)} / ${this.successResponse?.paymentTime}`
        }
      )
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: (this.successResponse.standingOrderId || this.successResponse.transactionReference) },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.processing') }
      ]
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: (this.successResponse.standingOrderId || this.successResponse.transactionReference)
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
    },
    isFuturePayment () {
      return this.config.payload.startDate !== this.currentDate
    },
    saveTransferData () {
      if (
        this.config.payload.paymentFrequency === 'ONCE' &&
        this.config.payload.startDate === this.currentDate
      ) {
        this.createFundTransfer()
      } else {
        this.createStandingOrder()
      }
    },
    async createFundTransfer () {
      this.$emit('domesticPaymentSuccessfull', { summaryDetails: this.summaryDetails })
    },
    async createStandingOrder () {
      let repeatPaymentData
      const oneTimePaymentData = {
        startDate: this.config.payload.startDate,
        endDate: this.endPeriodDate,
        frequency:
          this.config.payload.paymentFrequency === 'ONCE'
            ? 'DAILY'
            : this.config.payload.paymentFrequency,
        transferFromAccountDetails: [
          {
            accountId: this.config.payload.fromAcc,
            amount: {
              value: this.config.payload.transferAmount,
              currency: this.defaultCurrency
            }
          }
        ],
        transferToAccountDetails: [
          {
            accountId: this.config.payload.toAcc,
            amount: {
              value: this.config.payload.transferAmount,
              currency: this.defaultCurrency
            }
          }
        ]
      }
      repeatPaymentData = {
        customerId: JSON.parse(sessionStorage.getItem('username')), // customer Id
        description: this.config.payload.transferNote,
        paymentInstruction: {
          paymentSystem: this.UKFPSpaymentTemplate.paymentSystem, // UKFPS or STEP2 from Payment Template
          paymentType: 'ImmediatePayment', // ImmediatePayement for UKFPS, CreditTransfer for SEPA
          destinationCountry: this.UKFPSpaymentTemplate.country, // from Payment Template
          instructionAmount: {
            amount: Number(this.config.payload.transferAmount).toFixed(2), // amount input
            currency: this.defaultCurrency // amount currency
          },
          chargeAmount: {
            amount: 0.00,
            currency: 'GBP'
          },
          taxAmount: {
            amount: 0.00,
            currency: 'GBP'
          },
          debtorCustomerReference: JSON.parse(sessionStorage.getItem('username')), // customer id
          debtorAccountType: this.UKFPSpaymentTemplate.accountIdentificationType,
          debtorAccount: this.config.payload.fromAcc, // From Account number
          debtorBankIdentifier: this.UKFPSpaymentTemplate.standingOrderSetups.debtorBankIdentifier, // Sortcode from template,
          cdtrName: this.display.viewOnly.payeeAccountName, // Payee Name
          cdtrAccountType: this.UKFPSpaymentTemplate.accountIdentificationType, // PROPRIETARY for UKFPS, IBAN for SEPA
          cdtrAccount: this.config.payload.toAcc, // To Account -  IBAN Account Number for SEPA
          cdtrAddress: {
            CdtrPstlAdrAdrTp: 'RESIDENTIAL',
            CdtrPstlAdrCtry: this.UKFPSpaymentTemplate.country // from Payment Template
          },
          cdtrBankIdentifier: this.config.payload.payeeSortCode, // payee sort code
          remittanceInfoCtgyPurp: this.UKFPSpaymentTemplate.standingOrderSetups.remittanceInfoCtgyPurp, // from payment template
          chargesWaived: this.UKFPSpaymentTemplate.standingOrderSetups.chargesWaived // from payment template
        },
        standingOrderSetup: {
          frequency: this.config.payload.paymentFrequency, // input
          numberOfPayments: this.config.payload.frequencyMonths, // input
          fromDate: this.config.payload.startDate, // input
          payTillFurtherNotice: false,
          executionTime: '1100',
          setupCharge: this.UKFPSpaymentTemplate.standingOrderSetups.setupCharge, // from payment template
          amendCharge: this.UKFPSpaymentTemplate.standingOrderSetups.amendCharge, // from payment template
          successCharge: this.UKFPSpaymentTemplate.standingOrderSetups.successCharge, // from payment template
          failureCharge: this.UKFPSpaymentTemplate.standingOrderSetups.failureCharge // from payment template
        },
        channelId: 'DOB'
      }
      // Append endOfMonth flag - Only for MONTHLY frequency
      if (this.config.payload.paymentFrequency === 'MONTHLY') {
        repeatPaymentData.standingOrderSetup.endOfMonth = true
      }
      if (this.config.payload.paymentFrequency === 'ONCE' && this.currentDate !== this.config.startDate) {
        repeatPaymentData.standingOrderSetup.frequency = 'DAILY'
        repeatPaymentData.standingOrderSetup.numberOfPayments = 1
      }
      const response = this.config.payload.paymentFrequency === 'ONCE' && this.currentDate === this.config.startDate
        ? await commonService.postStandingOrder(oneTimePaymentData)
        : await commonService.interBankCreateStandingOrder(repeatPaymentData)

      if (response) {
        if (response?.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', response)
          return
        }
        this.onOtpModalClose()
        if (response?.causes?.[0]?.code) {
          if (response?.causes?.[0]?.code === '20600464') {
            this.dispatchError(this.$t('systemMessages.customMessages.20600464.title'), this.$t(response.causes[0].message.replace('Beneficiary', this.$t('systemMessages.customMessages.20600464.message'))))
          } else {
            this.dispatchError(this.$t('systemMessages.customMessages.20600123.title'), this.$t('systemMessages.customMessages.20600123.message'))
          }
        } else {
          this.successDialog = true
          this.successResponse = response
          event.$emit('is_UKFPS_TransferComplete', true)
          this.setConfirmationData()
          this.modalConfig.successModal.dataDetails = this.confirmationDetails
          this.modalConfig.successModal.body = this.$t('paymentSuccessDialog.yourTransactionReference') + ' ' + (this.successResponse.standingOrderId || this.successResponse.transactionReference)
          this.modalConfig.successModal.enabled = true
          await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
        }
      }
    },
    handleGoBack () {
      // TODO: handle back button
    }
  },
  computed: {
    isPayorLisa () {
      return this.config.payload.selectedPayor.accountType === 'TXLA'
    },
    totalLisaCharges () {
      return (this.config.payload?.lisaWithdrawalCharges ?? []).reduce((accumulator, charge) => {
        return accumulator +
          (charge?.chargeAmount?.value ?? 0) +
          (charge?.taxAmount?.value ?? 0)
      }, 0).toFixed(2)
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    },
    isInitiateDomesticFailed: {
      handler (val) {
        this.disableBtn = !val
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
    event.$off('download_payment_proof')
  }
}
</script>
